<style lang="less">
  @import './login.less';
</style>

<template>
  <div class="login">

    <div class="login-con">

      <div class="login-input" v-show="loginInput">
        <a class="login-inp-icon" @click="loginInputBtn"></a>
        <Card icon="log-in" title="傲基云" :bordered="false">
          <div class="form-con">
            <login-form @on-success-valid="handleSubmit"></login-form>
            <p class="login-tip">输入有效的用户名和密码</p>
          </div>
        </Card>
      </div>

      <div class="login-code" v-show="loginCode">
        <a class="login-code-icon" @click="loginCodeBtn"></a>
        <Card>
          <div class="code-div" id="wx_qrcode">
          </div>
        </Card>
      </div>

    </div>

    <div id="bottom_layer" class="s-bottom-layer s-isindex-wrap" style="visibility: visible; width: 100%">
      <div class="text-color" target="_blank" style="position:fixed; bottom:15px; width:100%; text-align:center; color: white;"> Copyright © 2018-2020 Aukey Cloud. All Rights Reserved. </div>
      <div class="text-color" target="_blank" style="position:fixed; bottom:0px; width:100%; text-align:center; color: white;"> 傲基云 版权所有 v.1.0.1 </div>
    </div>

  </div>

</template>
<script>
import LoginForm from '_c/login-form'
import { mapActions } from 'vuex'
import { monitorUserSync } from '@/api/monitor'
import { getToken } from '@/libs/util'
import config from '@/config'
export default {
  components: {
    LoginForm
  },
  data () {
    return {
      loginInput: false,
      loginCode: true,
      codeExpired: false
    }
  },
  mounted () {
    // console.log(config.wxAgentId, '---', config.baseUrl, '--', `${window.location.protocol}${config.baseUrl}`, window.location.hostname)
    // this.loadScript('https://rescdn.qqmail.com/node/ww/wwopenmng/js/sso/wwLogin-1.0.0.js', r => {
    //   window.WwLogin({
    //     id: 'wx_qrcode',
    //     appid: 'ww0f3efc2873ad11c3',
    //     agentid: config.wxAgentId,
    //     redirect_uri: `${window.location.protocol}${config.baseUrl}/api/v1/we_chat_auth/`,
    //     state: 'STATE',
    //     href: 'data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIwMHB4O30='
    //   })
    // })
    // 初始化
    // eslint-disable-next-line no-unused-vars
    const wwLogin = window.ww.createWWLoginPanel({
      el: '#wx_qrcode', // 登录组件挂载元素；可以指定 DOM 元素或 CSS 选择器
      params: { // 登录参数
        // 登录类型；ServiceApp-第三方应用登录；CorpApp-企业自建应用登录服务、商代开发应用登录
        login_type: 'CorpApp',
        // AppID登录类型为企业自建应用/服务商代开发应用时填企业 CorpID，第三方登录时填登录授权 SuiteID
        appid: 'ww0f3efc2873ad11c3',
        agentid: config.wxAgentId, // 企业自建应用/服务商代开发应用 AgentID
        redirect_uri: `${window.location.protocol}//${window.location.hostname}/auth/api/v1/we_chat_auth/`, // 登录成功重定向 url
        state: 'STATE', // 登录 state 用于保持请求和回调的状态，授权请求后原样带回给企业。
        // 登录成功跳转类型;
        // top-默认 - top window顶层页面跳转;
        // callback - 通过 onLoginSuccess 回调用户授权 code，开发者自行处理跳转
        // self - 登录组件跳转
        redirect_type: 'top',
        panel_size: 'small',
        href: 'data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIwMHB4O30='
      },
      // 获取企业微信桌面端登录状态回调
      onCheckWeComLogin ({ isWeComLogin }) {
        console.log(isWeComLogin)
      },
      // 企业微信登录成功回调,需配置 redirect_type=callback
      onLoginSuccess ({ code }) {
        console.log({ code })
        // 登录后的业务逻辑...
      },
      // 企业微信登录错误回调
      onLoginFail (err) {
        console.log(err)
      }
    })
  },

  watch: {
    $route: {
      handler: function (to) {
        if (navigator.userAgent.indexOf('wxwork') !== -1 && !getToken()) {
          console.log('微信客户端打开了网页', to.query.redirect, window.location)
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww0f3efc2873ad11c3&redirect_uri=${config.baseUrl}/api/v1/we_chat_auth_by_cs/&response_type=code&scope=snsapi_base&agentid=${config.wxAgentId}&state=${to.query.redirect}#wechat_redirect`
        }
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    loadScript (src, callback) {
      let script = document.createElement('script')
      script.type = 'text/javascript'
      if (callback) script.onload = callback
      document.querySelector('body').appendChild(script)
      script.src = src
    },
    ...mapActions([
      'handleLogin',
      'getUserInfo'
    ]),
    handleSubmit ({ userName, password }) {
      // 默认扫码登录  只能admin可以账号密码登录系统
      if (userName !== 'admin' && process.env.NODE_ENV !== 'development') {
        this.$Notice.error({
          title: '非超级管理员不允许账号密码登录!'
        })
        return
      }
      this.handleLogin({ userName, password }).then(res => {
        this.$Notice.success({
          title: '登录成功！'
        })
        this.sync()
        if (this.$route.query.redirect) {
          this.$router.push({ path: this.$route.query.redirect })
        } else {
          this.$router.push({
            name: this.$config.homeName
          })
        }
      }).catch(err0 => {
        if (!err0.request) {
          this.$Notice.error({
            title: '登录失败！'
          })
          return
        }
        if (err0.request.status === 400) {
          this.$Notice.error({
            title: '用户名或密码错误！'
          })
        } else {
          this.$Notice.error({
            title: '登录失败！ 错误状态码:' + err0.request.status,
            desc: err0.request.responseText
          })
        }
      })
    },
    // 开始同步
    sync () {
      monitorUserSync().then(res => {
      }).catch(res => {
      })
    },
    // 输入框登录
    loginInputBtn () {
      this.loginInput = false
      this.loginCode = true
    },
    // 二维码登录
    loginCodeBtn () {
      this.loginInput = true
      this.loginCode = false
    },
    // 刷新
    breakCode () {
      this.codeExpired = false
    }
  }
}
</script>

<style lang="less">
.login-input{
  .login-inp-icon{
    width:50px;
    height: 50px;
    display: block;
    background: url("../../assets/images/login-code.png") no-repeat;
    position:absolute;
    right:0;
    top:0;
    z-index: 1;
  }
  .ivu-card-head {
    p {
      font-weight: 700;
    }
  }
  .ivu-card-head p i, .ivu-card-head p span {
    vertical-align: middle;
  }
}
.login-code{
  .login-code-icon{
    width:50px;
    height: 50px;
    display: block;
    background: url("../../assets/images/login-input.png") no-repeat;
    position:absolute;
    right:0;
    top:0;
    z-index: 1;
  }
  .ivu-card{
    width: 400px;
    height: 420px;
    text-align:center;
    .code-div{
      margin: auto;
      margin-top: 30px;
      margin-bottom: 15px;
      position: relative;
    }
    .code-expired{
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: rgba(255,255,255,0.9);
      .ivu-btn{
        padding: 4px 12px 2px;
        background: #F5F5F5;
      }
      p{
        margin: 80px 0 20px;
      }
    }
  }
}
</style>
